import { AppointmentPDF } from '@avanta/shared/components/AppointmentPDF';
import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useFetchPatient } from '@avanta/shared/hooks/useFetchPatient';
import { t } from '@avanta/shared/i18n';
import { cn } from '@avanta/shared/utils/cn';
import { openPDF } from '@avanta/shared/utils/storage';
import { File } from 'lucide-react';
import { type DownloadAppointmentPDFProps } from './types';

export const DownloadAppointmentPDF = ({
  appointment,
  icon,
  buttonLabel = t('DownloadAppointmentPDF.cta', { ns: LOCIZE_NS.APPOINTMENTS }),
  className,
}: DownloadAppointmentPDFProps): React.ReactElement | null => {
  const { data: patient } = useFetchPatient(appointment.patientId);

  if (!patient) return null;

  const handleDownloadAppointmentPdf = async (): Promise<void> => {
    openPDF({
      pdfComponent: <AppointmentPDF appointment={appointment} patient={patient} />,
      filename: appointment.dateTime,
    });
  };

  return (
    <Button
      variant="ghost"
      className={cn(
        'has-[>svg]:p-0 flex items-center gap-2 text-teal-600 hover:text-teal-500 hover:bg-transparent',
        className
      )}
      icon={icon ?? 'leading'}
      size="lg"
      onClick={handleDownloadAppointmentPdf}
    >
      <File className="size-4" />
      {icon !== 'only' && buttonLabel}
    </Button>
  );
};
